import { render, staticRenderFns } from "./Cenniki.vue?vue&type=template&id=87fad8f8&scoped=true&"
import script from "./Cenniki.vue?vue&type=script&lang=js&"
export * from "./Cenniki.vue?vue&type=script&lang=js&"
import style0 from "./Cenniki.vue?vue&type=style&index=0&id=87fad8f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fad8f8",
  null
  
)

export default component.exports